import { StoreDealsTabContentProps } from '..';
import { StoreDeal } from '../../../../../domain/entities/Store';
import { StoreDealsTabList } from './style';
import { StoreDealCard } from '../StoreDealCard';

type StoreDealsListProps = Pick<
  StoreDealsTabContentProps,
  'userOffersVote' | 'onVote' | 'onRemoveVote'
> & {
  deals: StoreDeal[];
};
export const StoreDealsList = ({
  deals,
  userOffersVote,
  onRemoveVote,
  onVote,
}: StoreDealsListProps) => (
  // TODO: [sc-18704] Remove all this logic from return
  <StoreDealsTabList role="list">
    {deals.map((deal, index) => (
      <StoreDealCard
        key={deal.id}
        deal={deal}
        onVote={onVote}
        onRemoveVote={onRemoveVote}
        cardPosition={index}
        userOffersVote={userOffersVote}
      />
    ))}
  </StoreDealsTabList>
);
